<template>
  <v-card class="ma-4">
    <v-card-title style="text-align: left">Principais Indicadores</v-card-title>
    <v-card-text>
      <v-row class="pa-3">
        <v-col cols="12" sm="4" lg="4" xl="4" class="col-bordered">
          <span class="key-title">Produção média (l/dia): </span>
          <span class="value-title">
            {{
              relatorio.producaoMedia
                ? relatorio.producaoMedia
                : 'Não informado'
            }}
          </span>
        </v-col>
        <v-col cols="12" sm="4" lg="4" xl="4" class="col-bordered">
          <span class="key-title">Proteína média:</span>
          <span class="value-title">
            {{ relatorio.proteinaMediaUltimoMes + ' %' || 'Não informado' }}
          </span>
        </v-col>
        <v-col cols="12" sm="4" lg="4" xl="4" class="col-bordered">
          <span class="key-title">Gordura média: </span>
          <span class="value-title">{{
            relatorio.gorduraMediaUltimoMes + ' %' || 'Não informado'
          }}</span>
        </v-col>
        <v-col cols="12" sm="6" lg="6" xl="6" class="col-bordered">
          <span class="key-title">CPP média: </span>
          <span class="value-title">{{
            relatorio.cppMedia
              ? relatorio.cppMedia + ' UFC/ml * 10³'
              : 'Não informado'
          }}</span>
        </v-col>
        <v-col cols="12" sm="6" lg="6" xl="6" class="col-bordered">
          <span class="key-title">CCS média: </span>
          <span class="value-title">{{
            relatorio.ccsMedia
              ? relatorio.ccsMedia + ' céls/ml * 10³'
              : 'Não informado'
          }}</span>
        </v-col>
        <v-col cols="12" sm="6" lg="6" xl="6" class="col-bordered">
          <span class="key-title">Número de vacas em lactação: </span>
          <span class="value-title">{{
            relatorio.mediaVacasEmlactacao
              ? relatorio.mediaVacasEmlactacao
              : 'Não informado'
          }}</span>
        </v-col>
        <v-col cols="12" sm="6" lg="6" xl="6" class="col-bordered">
          <span class="key-title">Número de vacas secas: </span>
          <span class="value-title">{{
            relatorio.numDeVacasSecas
              ? relatorio.numDeVacasSecas
              : 'Não informado'
          }}</span>
        </v-col>
        <v-col cols="12" class="col-bordered">
          <span class="key-title"
            >Número de pessoas envolvidas no manejo do rebanho:
          </span>
          <span class="value-title">{{
            relatorio.numPessoasEnvolvidasNoManejoDoRebanho
              ? relatorio.numPessoasEnvolvidasNoManejoDoRebanho
              : 'Não informado'
          }}</span>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { convertNumberBR } from '../../../../utils/masks'
export default {
  name: 'IndicadoresQualidade',
  props: {
    relatorio: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },

  data() {
    return {
      rotate: -90,
      chartOptionsObrigatorio: {
        legend: 'none',
        chartArea: { height: '80%', width: '50%' },
        tooltip: { isHtml: true, trigger: 'none' },
        responsive: true,
        maintainAspectRatio: false,
        pieHole: 0.85,
        pieSliceText: 'none',
        slices: {
          0: { color: '#dd2c00' },
          1: { color: '#ff6e40' },
        },
      },
      chartOptionsRelevante: {
        legend: 'none',
        chartArea: { height: '80%', width: '50%' },
        tooltip: { isHtml: true, trigger: 'none' },
        responsive: true,
        maintainAspectRatio: false,
        pieHole: 0.85,
        pieSliceText: 'none',
        slices: {
          0: { color: '#ff6f00' },
          1: { color: '#ffe0b2' },
        },
      },
      chartOptionsAceitavel: {
        legend: 'none',
        chartArea: { height: '80%', width: '50%' },
        tooltip: { isHtml: true, trigger: 'none' },
        responsive: true,
        maintainAspectRatio: false,
        pieHole: 0.85,
        pieSliceText: 'none',
        slices: {
          0: { color: '#1b5e20' },
          1: { color: '#43a047' },
        },
      },
    }
  },

  methods: { convertNumberBR },
}
</script>

<style scoped>
.key-title {
  font-weight: 500;
  font-size: '16px';
}

.value-title {
  font-size: '16px';
}

.col-bordered {
  border: solid 1px #ccc;
}

section {
  width: auto;
  height: 200px;
  text-align: center;
  max-width: 400px;
}

section p {
  position: relative;
  margin-top: -35%;
  font-size: 30px;
}
</style>
